import { defineStore } from 'pinia'
import { ref } from 'vue'
import { type SaleOrder, SaleOrderApi } from '@/api-swagger'

export const useSaleOrdersStore = defineStore('saleOrder', () => {
  const saleOrders = ref<SaleOrder[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)
  const api = new SaleOrderApi()

  const getSaleOrders = async (userId: number, partnerId: number) => {
    loading.value = true
    error.value = null
    saleOrders.value = []
    try {
      await api
        .getSaleOrderByUserIdAndPartnerId({ userId: userId, partnerId: partnerId })
        .then((res) => {
          saleOrders.value = res
        })
        .catch(() => {
          error.value = 'SaleOrder non trouvés.'
        })
    } catch (err) {
      console.error('Erreur API :', err)
    } finally {
      loading.value = false
    }
  }

  return {
    saleOrders,
    loading,
    error,
    getSaleOrders,
  }
})
